import { PayloadAction } from '@reduxjs/toolkit';
import { updateQuestionPackages } from './form.thunks';
import { IQuestionPackageState } from './questionPackagesState';
import { Features, isFeatureEnabled } from '../../featureToggles/features';
import { fetchQuestionPackages } from '../accounts/projects/projects.thunks';

export const extraReducers = {
  [updateQuestionPackages.pending.type]: (state: IQuestionPackageState): void => {
    if (!isFeatureEnabled(Features.QlNetquest)) {
      return;
    }
    state.saving = true;
    state.error = null;
  },
  [updateQuestionPackages.fulfilled.type]: (state: IQuestionPackageState): void => {
    if (!isFeatureEnabled(Features.QlNetquest)) {
      return;
    }
    state.saving = false;
  },
  [updateQuestionPackages.rejected.type]: (state: IQuestionPackageState, action: PayloadAction<string>): void => {
    if (!isFeatureEnabled(Features.QlNetquest)) {
      return;
    }
    state.saving = false;
    state.error = action.payload;
  },
  [fetchQuestionPackages.pending.type]: (state: IQuestionPackageState): void => {
    if (!isFeatureEnabled(Features.QlNetquest)) {
      return;
    }
    state.fetching = true;
    state.error = null;
  },
  [fetchQuestionPackages.fulfilled.type]: (state: IQuestionPackageState, action: PayloadAction<string[]>): void => {
    if (!isFeatureEnabled(Features.QlNetquest)) {
      return;
    }
    state.fetching = false;
    state.questionsPackages = action.payload;
  },
  [fetchQuestionPackages.rejected.type]: (state: IQuestionPackageState, action: PayloadAction<string>): void => {
    if (!isFeatureEnabled(Features.QlNetquest)) {
      return;
    }
    state.fetching = false;
    state.error = action.payload;
    state.questionsPackages = [];
  }
};

export default extraReducers;
